<template>
  <div class="md:hidden">
    <button
      class="mc-mobile-toggle"
      @click="$emit('toggle')"
    >
      <span class="inline-flex items-center">
        <template v-if="isOpen">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" transform="matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,0)">
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="m7 14 5-5 5 5z"></path>
          </svg> 
          <span class="ml-2">Close Categories</span>
        </template>
        <template v-else>
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="24px" width="24px" xmlns="http://www.w3.org/2000/svg">
            <path d="M128 192l128 128 128-128z"></path>
          </svg>
          <span class="ml-2">Open Categories</span>
        </template>
      </span>
    </button>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

// Define props using defineProps
defineProps({
    isOpen: Boolean
});
</script>

<style scoped>
.mc-mobile-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.75rem;
  background-color: #1e1e1e;
  color: #ffffff;
  transition: all 0.2s ease;
  font-family: 'Roboto', sans-serif;
  text-transform: capitalize;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
}

.mc-mobile-toggle:hover {
  background-color: #2a2a2a;
  transform: scale(1.01);
}

.mc-mobile-toggle::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 0 0 2px #000;
  border-radius: 20px;
  pointer-events: none;
}
</style>